import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConfirmLoanAllocationModal } from '../../../common/modals';
import { connectModal } from '../../../features/modal/hoc';
import { selectData } from '../../../features/modal/ducks';
import { confirmAllocationActions, resendSmsCodeAllocationRequest } from '../ducks';
import { apiCallIds } from '../api';

const mapStateToProps = state => ({
  allocationId: selectData(state, apiCallIds.CONFIRM_ALLOCATION),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      confirmAllocation: confirmAllocationActions.request,
      resendSmsCodeAllocation: resendSmsCodeAllocationRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.CONFIRM_ALLOCATION)
export default class ConfirmAllocation extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    allocationId: PropTypes.string,
  };

  handleResendSmsCode = callbacks => {
    const { actions, allocationId } = this.props;
    actions.resendSmsCodeAllocation({ allocationId, ...(callbacks || {}) });
  };

  handleSubmit = token => {
    const { actions, allocationId } = this.props;
    actions.confirmAllocation({ allocationId, token });
  };

  render() {
    const { isVisible, isLoading, modalActions, allocationId } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <ConfirmLoanAllocationModal
        hideModal={modalActions.hide}
        isLoading={isLoading}
        onSubmit={this.handleSubmit}
        onResendSmsCode={this.handleResendSmsCode}
        resendCooldownKey={`allocation:${allocationId}`}
        isAllocation
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/components/ConfirmAllocation.js